<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    侨城北站<br>
站点介绍<br>
侨城北站位于深圳市南山区侨香路下方，大致呈东西走向，东接深康站，西接世界之窗站。北侧是规划工业用地，南侧是规划居住用地。本站为地下两层车站，地下二层为站台层，地下一层为站厅层，站台形式为岛式站台。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:32	00:12	2号线	2分35秒	5分45秒<br>
莲塘	06:02	23:29	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:36	00:11	2号线	4分钟	5分钟<br>
莲塘	06:06	23:29	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:36	01:01	2号线	4分钟	5分钟<br>
莲塘	06:06	00:29	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
B出入口:<br>
华侨城医院、侨香路南侧、香山东街、天鹅堡<br><br>
C出入口:<br>
侨香路北侧、沙河中行工业区<br><br>
D出入口:<br>
侨香路北侧、香年广场、智慧广场、沙河建工村<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 华侨城医院<br>
72、316、326、104、M561、107、高峰166、高峰专线119、B729、高峰专线62<br><br>
B出入口:<br>
公交站名： 华侨城医院南<br>
M486<br><br>
C出入口:<br>
公交站名： 华侨城医院<br>
72、316、326、104、M561、高峰专线62、高峰专线119、B729、高峰166<br><br>
C出入口:<br>
公交站名： 侨城北地铁站<br>
B661<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>